import React, { useEffect } from 'react';
import ModalBasic from '../../components/infrastructure/Modals/ModalBasic';
import { useFormik } from 'formik';
import { object, string } from 'yup';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import FormikInputDateGroup from '../../components/formik/FormikInputDateGroup';
import FormikInputGroup from '../../components/formik/FormikInputGroup';
import { useDispatch, useSelector } from 'react-redux';
import {
    editComplaint,
    fetchComplaints,
} from '../../app/reducers/Complaints/complaintSlice';
import { getAuth } from '../../app/reducers/Auth/authSlice';
import moment from 'moment';

const TimeInModal = ({
    openTimeInModal,
    setOpenTimeInModal,
    complaintData,
    page,
    status,
}) => {
    const dispatch = useDispatch();
    const { user } = useSelector(getAuth);
    const isEngineerOrExecutive = ['engineer', 'executive','sales'].includes(user?.role);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            ...complaintData,
            timeInDate: '',
        },
        validationSchema: object({
            timeInDate: string().required('TimeIn date is required'),
        }),
        onSubmit: async (values) => {
            await dispatch(editComplaint({ ...values, status: 'timeIn' }));
            await dispatch(fetchComplaints({ populate: true, page, status }));
            setOpenTimeInModal(false);
            formik.resetForm();
        },
    });

    useEffect(() => {
        if (openTimeInModal) {
            formik.setFieldValue('timeInDate', moment().valueOf());
        }
    }, [openTimeInModal]);

    return (
        <ModalBasic
            modalOpen={openTimeInModal}
            setModalOpen={setOpenTimeInModal}
            title="Move to TimeIn"
            max_width="max-w-lg"
        >
            <form
                className="flex flex-col gap-4 p-5"
                onSubmit={formik.handleSubmit}
            >
                <div className="grid grid-cols-2 gap-3 pb-4 border-b border-slate-200">
                    <FormikInputGroup
                        formik={formik}
                        label="Complaint No."
                        value={`CMP-${formik.values.complaintNumber || ''}`}
                        name="complaintNumber"
                        readOnly
                    />
                    <FormikInputGroup
                        formik={formik}
                        label="Customer"
                        name="customer.name"
                        readOnly
                    />
                    <FormikInputGroup
                        formik={formik}
                        label="Company"
                        name="customer.companyData.name"
                        readOnly
                    />
                    <FormikInputGroup
                        formik={formik}
                        label="Machine"
                        name="product.name"
                        readOnly
                    />
                    <FormikInputGroup
                        formik={formik}
                        label="Technician"
                        name="assignedTo"
                        readOnly
                    />
                    <div className="col-span-2">
                        <FormikInputGroup
                            formik={formik}
                            label="Description"
                            name="description"
                            readOnly
                            fullWidth
                        />
                    </div>
                </div>

                <FormikInputDateGroup
                    formik={formik}
                    label="TimeIn Date"
                    name="timeInDate"
                    required
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    dateFormat="dd/MM/yyyy HH:mm"
                    readOnly={isEngineerOrExecutive}
                />

                <div className="mt-auto">
                    <PrimaryButton
                        type="submit"
                        disabled={formik.isSubmitting}
                        className="w-full"
                    >
                        {formik.isSubmitting ? 'Saving...' : 'Submit'}
                    </PrimaryButton>
                </div>
            </form>
        </ModalBasic>
    );
};

export default TimeInModal;
